import React, { Component } from 'react';
import { View } from 'modules/styled';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from 'modules/auth/auth.actions';
import * as userActions from 'modules/user/user.actions';
import * as postActions from 'modules/post/post.actions';
import * as commentActions from 'modules/comment/comment.actions';
import * as statsActions from 'modules/stats/stats.actions';
import * as investActions from 'modules/post/invest.actions';
import * as createPostActions from 'modules/createPost/createPost.actions';
import * as navigationActions from 'modules/navigation/navigation.actions';
import * as animationActions from 'modules/animation/animation.actions';
import * as tooltipActions from 'modules/tooltip/tooltip.actions';
import CustomSpinnerRelative from 'modules/ui/mobile/customSpinnerRelative.component';
import ErrorComponent from 'modules/ui/mobile/error.component';
import SinglePost from './singlePost.component';

class SinglePostContainer extends Component {
  static propTypes = {
    navigation: PropTypes.object,
    actions: PropTypes.object,
    comments: PropTypes.object,
    users: PropTypes.object,
    auth: PropTypes.object,
    error: PropTypes.bool,
    posts: PropTypes.object,
  };

  state = {
    inputHeight: 0,
    editing: false,
    comment: null,
  };

  componentDidMount() {
    const { auth, actions, navigation } = this.props;
    const { community } = navigation.state.params;
    if (community && auth.community !== community) actions.setCommunity(community);
    requestAnimationFrame(() => {
      this.getPost();
    });
  }

  componentWilUnmount() {
    this.didBlurSubscription?.remove();
  }

  componentDidUpdate() {
    // TODO this is not needed if we don't wipe post reducer
    const { auth, navigation } = this.props;
    const { community } = navigation.state.params;

    // we add listeners so we can reset the route in case we ever navigate away
    // and change the community
    this.didBlurSubscription?.remove();
    this.didFocusSubscription = navigation.addListener('didFocus', () => {
      if (community && auth.community !== community) navigation.popToTop();
    });

    if (!navigation.state?.params?.title) this.setTitle(this.props);
  }

  getPost = () => {
    const { posts, navigation } = this.props;
    const { id } = navigation.state.params;
    const post = posts.posts[id];
    if (!post) this.props.actions.getSelectedPost(id);
    this.props.actions.getComments(id);
  };

  setTitle() {
    const { posts, navigation } = this.props;
    const { id } = navigation.state.params;
    const post = posts.posts[id];
    if (!post) return;

    const link = post && posts.links[post.metaPost];
    const title = post.title || post.body || link.title;

    if (!this.props.navigation.state.params || title !== navigation.state.params.title) {
      navigation.setParams({ title });
    }
  }

  setEditing = (bool) => {
    this.setState({ editing: bool });
  };

  reload = () => {
    const { id } = this.props.navigation.state.params;
    this.props.actions.getSelectedPost(id);
    this.props.actions.getComments(id);
  };

  render() {
    const { posts, navigation, error, auth } = this.props;
    const { id } = navigation.state.params;
    const post = posts.posts[id];

    // const related = posts.related[id] || [];
    const link = post && posts.links[post.metaPost];

    const community = post?.data?.community;
    const loading = community && auth.community !== community;

    if (error && !post) {
      return (
        <ErrorComponent
          error={error}
          parent={'singlepost'}
          reloadFunction={this.reload}
        />
      );
    }

    return (
      <View sx={{ flex: 1 }}>
        {loading || (!post && !error) ? (
          <CustomSpinnerRelative visible={true} />
        ) : (
          <SinglePost
            postId={id}
            post={post}
            link={link}
            singlePostEditing={this.setEditing}
            error={this.error}
            {...this.props}
          />
        )}
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    posts: state.posts,
    user: state.user,
    error: state.error.singlepost,
    comments: state.comments,
    users: state.user,
    tags: state.tags,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...statsActions,
        ...authActions,
        ...commentActions,
        ...postActions,
        ...animationActions,
        ...investActions,
        ...userActions,
        ...createPostActions,
        ...navigationActions,
        ...tooltipActions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SinglePostContainer);
